import { useContext } from 'react';
import ObservabilityConfigContext from '../internal/config/ObservabilityConfigContext';
/**
 * @see https://sail.stripe.me/apis/observability/useObservabilityConfig
 */ export default function useObservabilityConfig() {
    return useContext(ObservabilityConfigContext);
}

//# sourceMappingURL=useObservabilityConfig.js.map